import React, { useContext, useState } from 'react';

import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import { AppContext } from '../../../context';

import Style from './Navbar.module.css';

import { signOut } from '../../../redux/actions/auth';

import { Button } from '../../atoms';

import { pushEventInLoggy } from '../../../utils/loggy';

function Navbar({ showSidebar }) {
  const { isMobile } = useContext(AppContext);
  const [display, setDisplay] = useState(false);
  const [help, setHelp] = useState(false);
  const { my_profile } = useSelector((state) => state);
  const router = useRouter();
  const dispatch = useDispatch();
  const pathname = router?.pathname;
  const isAdmin = my_profile?.data?.data?.user?.user_type === 'admin';
  const isFinance = my_profile?.data?.data?.user?.user_type === 'finance';

  const showOptions = () => {
    setDisplay(!display);
  };
  const handleLogin = () => {
    router.push('/login');
  };

  const showHelp = () => {
    setHelp(!help);
  };

  const handleProfileNav = () => {
    pushEventInLoggy(
      {
        event: 'Open_Profile_Dashboard',
        page_name: 'Candidate Dashboard'
      },
      my_profile
    );
    showOptions();
    router.push('/profile');
  };

  const handleReferralsNav = () => {
    showOptions();
    router.push('/my-referrals');
  };

  const handleLogout = () => {
    showOptions();
    dispatch(signOut())
      .then(() => {
        router.reload();
      })
      .catch(() => {});
  };

  const initials = my_profile?.data?.data?.first_name?.[0] + my_profile?.data?.data?.last_name?.[0];

  const handleEventTrigger = (event_name) => {
    pushEventInLoggy(
      {
        event: event_name,
        page_name: 'Candidate Dashboard'
      },
      my_profile
    );

    router.push(event_name === 'FAQ_Browse_Job' ? '/faqs' : '/why-awign');
  };

  return (
    <div className={`${Style.NavbarWeb} sticky-top`}>
      <div className={isMobile ? 'container height100per' : 'container height100per'}>
        <nav className='navbar navbar-expand-lg sticky-top navbar-light bg-light'>
          <div className={my_profile?.data ? 'w-100 center-y' : 'w-100 center-y'}>
            <button
              aria-controls='navbarTogglerDemo02'
              aria-expanded='false'
              aria-label='Toggle navigation'
              className='navbar-toggler'
              data-bs-target='#navbarTogglerDemo02'
              data-bs-toggle='collapse'
              onClick={showSidebar}
              type='button'
            >
              <span className='navbar-toggler-icon' />
            </button>
            <a className={isMobile ? 'navbar-brand p-l-10' : 'navbar-brand'} href='/'>
              <img className={Style.ExpertLogo} height={27} src={isMobile ? '/images/login/logo-mob.svg' : '/images/login/logo.svg'} width={200} />
            </a>
            <div className={`${Style.hiddenInMob} center-x`}>
              {isAdmin ? (
                <>
                  <a className={pathname?.includes('/jobs') ? ' p-y-16 p-x-20 border-bottom-black-2px' : ' p-y-16 p-x-20'} href='/admin/jobs'>
                    <div className='black font-16px line-height-19'>Jobs</div>
                  </a>
                  <a className={pathname?.includes('/applications') ? ' p-y-16 p-x-20 border-bottom-black-2px ' : ' p-y-16 p-x-20'} href='/admin/applications'>
                    <div className='black font-16px line-height-19'>Applications</div>
                  </a>
                  <a
                    className={pathname?.includes('/engagements') && !pathname?.includes('/engagements-dashboard') ? ' p-y-16 p-x-20 border-bottom-black-2px ' : ' p-y-16 p-x-20'}
                    href='/admin/engagements'
                  >
                    <div className='black font-16px line-height-19'>Engagements</div>
                  </a>
                  <a className={pathname?.includes('/timesheets') ? ' p-y-16 p-x-20 border-bottom-black-2px ' : ' p-y-16 p-x-20'} href='/admin/timesheets'>
                    <div className='black font-16px line-height-19'>Timesheets</div>
                  </a>
                  <a className={pathname?.includes('/payments') ? ' p-y-16 p-x-20 border-bottom-black-2px ' : ' p-y-16 p-x-20'} href='/admin/payments'>
                    <div className='black font-16px line-height-19'>Payments</div>
                  </a>
                </>
              ) : isFinance ? (
                <a className={pathname?.includes('/payments') ? 'm-r-50 p-y-16 border-bottom-black-2px ' : 'm-r-50 p-y-16'} href='/finance/payments'>
                  <div className='black font-16px line-height-19'>Payments</div>
                </a>
              ) : (
                <>
                  <a className={pathname?.includes('/jobs/') ? 'm-r-50 p-y-16 border-bottom-black-2px ' : 'm-r-50 p-y-16'} href='/jobs/explore'>
                    <div className='black font-16px line-height-19'>Explore Jobs</div>
                  </a>
                  <>
                    {my_profile?.data ? (
                      <a className={pathname?.includes('/engagements') ? 'p-y-16 border-bottom-black-2px' : 'p-y-16'} href='/engagements?tab=active&section=overview'>
                        <div className='black font-16px line-height-19'>My Engagements</div>
                      </a>
                    ) : null}
                  </>
                </>
              )}
            </div>
            {!my_profile?.data ? (
              <div className='flexStyleStart ml-auto'>
                <div className={`${Style.hiddenInMob} padding0`}>
                  <div className='p-r-l-10'>
                    <div className='marginTopAuto border-right-grey'>
                      <img className='padding8T pointer p-10' onClick={showHelp} src='/images/job-dashboard/help-icon.svg' />
                    </div>
                  </div>
                </div>
                <Button className='general-style' onClick={handleLogin}>
                  Candidate Sign In
                </Button>
              </div>
            ) : (
              <div className={`${Style.hiddenInMob} ml-auto`}>
                <div className='flexStyleStart'>
                  {!isAdmin ? (
                    <div className='relative'>
                      <div className='p-r-l-10'>
                        <div className='marginTopAuto border-right-grey '>
                          <img className='padding8T pointer p-10' onClick={showHelp} src='/images/job-dashboard/help-icon.svg' />
                        </div>
                      </div>
                      {help ? (
                        <div className={`absolute r-0 ${Style.helpOptions} ${Style.profileOptions}`}>
                          <div>
                            <div className='flexStyleStart' onClick={() => handleEventTrigger('FAQ_Browse_Job')}>
                              <img src='/images/job-dashboard/user-octagon.svg' />
                              <div className='black font-14px line-height-18 medium'>FAQs</div>
                            </div>
                          </div>
                          <div>
                            <div className='flexStyleStart' onClick={() => handleEventTrigger('Why_AEx_Browse_Job')}>
                              <img src='/images/job-dashboard/share.svg' />
                              <div className='black font-14px line-height-18 medium'>Why Awign Expert?</div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div className={`${Style.initials}`}>
                    <div>{initials}</div>
                  </div>
                  <div className='relative'>
                    <div className={classNames(!isAdmin ? `${Style.fullName}` : `padding0 ${Style.fullName}`, 'pointer')} onClick={showOptions}>
                      <div>{my_profile?.data?.data?.full_name}</div>
                      <img className='setPointer' src='/images/job-dashboard/arrow-down.svg' />
                    </div>
                    {isAdmin ? <div className='gray font-12px fw-400 line-height-16 m-l-10'>Pay rolling Team</div> : null}
                    {isFinance ? <div className='gray font-12px fw-400 line-height-16 m-l-10'>Finance Team</div> : null}
                    {display ? (
                      <div className={`${Style.profileOptions} absolute r--10`}>
                        {!isAdmin ? (
                          <>
                            <div className='flexStyleStart' onClick={handleProfileNav}>
                              <img src='/images/job-dashboard/user-octagon.svg' />
                              <div>My Profile</div>
                            </div>
                            <div className='flexStyleStart' onClick={handleReferralsNav}>
                              <img src='/images/job-dashboard/share.svg' />
                              <div>My Referrals</div>
                            </div>
                          </>
                        ) : null}
                        <div className='flexStyleStart' onClick={handleLogout}>
                          <img src='/images/job-dashboard/logout.svg' />
                          <div>Logout</div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
